import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useData, DEFAULT_COLORS } from '@/components/widget/visualizations/RadarChart';
import { useRadarStyles } from '@/components/widget/visualizations/RadarChart/stylesTheme';
import { LegendFields } from '@/components/Editor/Form/fields/Legend';
import { jsx as _jsx } from "react/jsx-runtime";

const WidgetEditFormRadarChartLegends = _ref => {
  let {
    nameSpace,
    config,
    selectionResults,
    onChange,
    onEditSelections
  } = _ref;
  const {
    themeStyles,
    themeCtx: {
      colorPallet: defaultColorPallet = DEFAULT_COLORS
    }
  } = useRadarStyles(config);
  const {
    selectionsStrategy = 'default',
    seriesOptions = [],
    collectionOptions = [],
    globalSeriesOptions,
    colorPallet = defaultColorPallet
  } = config; // Combine results with rendering styles

  const {
    chartData
  } = useData({
    results: selectionResults,
    globalSeriesOptions: globalSeriesOptions || {},
    seriesOptions,
    collectionOptions,
    colorPallet,
    selectionsStrategy,
    themeStyles
  });
  return /*#__PURE__*/_jsx(LegendFields, _objectSpread({
    nameSpace: nameSpace,
    legendPosition: config.legendPosition,
    legends: config.legends,
    hasLegend: config.hasLegend ?? false,
    legendsCount: chartData.legendsCount,
    hasLegendInputs: true,
    onChange: updates => onChange('', updates)
  }, onEditSelections && {
    onEditSelections: () => onEditSelections('legends')
  }));
};

export default WidgetEditFormRadarChartLegends;